(() => {
  if (window.lkProductFollowMedia) return;
  window.lkProductFollowMedia = true;
  const mediaQuery = window.matchMedia('(min-width: 990px)');
  let observer;
  let frame;
  let targets = [];
  const update = () => {
    frame = null;
    const header = document.querySelector('header');
    const headerHeight = header?.getBoundingClientRect().height || 94;
    const cart = document.querySelector('[data-lk-sticky-cart]');
    const bottomSpace = Math.max(16, (cart?.getBoundingClientRect().height || 0) + 32);
    const viewportHeight = document.documentElement.clientHeight;
    const values = targets.map(element => {
      const gallery = element.querySelector('lk-product-gallery');
      if (!gallery) return {
        element,
        top: Math.round(Math.min(headerHeight + 16, viewportHeight - element.getBoundingClientRect().height - bottomSpace))
      };
      const top = Math.round(headerHeight + 40);
      const viewport = gallery.querySelector('[data-lk-gallery-viewport]');
      const extraHeight = element.getBoundingClientRect().height - (viewport?.getBoundingClientRect().height || 0);
      const height = Math.max(1, Math.floor(Math.min(gallery.clientWidth * 0.76, viewportHeight - top - bottomSpace - extraHeight)));
      return { element, gallery, top, height };
    });
    values.forEach(({ element, gallery, top, height }) => {
      if (mediaQuery.matches) {
        element.style.setProperty('--lk-product-follow-top', top + 'px');
        if (gallery) {
          const value = height + 'px';
          if (gallery.style.getPropertyValue('--lk-product-gallery-height') !== value) {
            gallery.style.setProperty('--lk-product-gallery-height', value);
            gallery.position?.(true);
          }
        }
      } else {
        element.style.removeProperty('--lk-product-follow-top');
        gallery?.style.removeProperty('--lk-product-gallery-height');
      }
    });
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const init = () => {
    observer?.disconnect();
    targets = [...document.querySelectorAll('.lk-product-page.lk-mobile-product-standard .lk-product-page__media')];
    if (targets.length) targets.push(...document.querySelectorAll('.product-full-width-video__video-column'));
    observer = new ResizeObserver(schedule);
    [...targets, document.querySelector('header'), document.querySelector('[data-lk-sticky-cart]')].filter(Boolean).forEach(element => observer.observe(element));
    schedule();
  };
  window.addEventListener('resize', schedule, { passive: true });
  mediaQuery.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  document.addEventListener('page:loaded', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
